import { fetchActivationStatus } from "@/apis/xpConditions"

const timerIds = {}

export default {
  initiateLongPooling({ commit, state }, { uuid, condition_id, name }) {
    commit("SET_JOB_DETAILS", { name, uuid, condition_id, progress: 0 })

    const getStatusAndInitiateTimer = () => {
      fetchActivationStatus(condition_id, uuid).then(res => {
        const { progress, status } = res.data
        commit("SET_STATUS", {
          progress: progress ? parseInt(progress) : 0,
          condition_id,
          status,
        })
        // clean up on completion
        if (res.data.result.status) {
          setTimeout(() => {
            clearTimeout(timerIds[condition_id])
            commit("REMOVE_PROGRESS", condition_id)
            /* eslint-disable-next-line no-underscore-dangle */
            this._vm.$noty.success(
              `Activation job for "${name}" was successful.`,
              { timeout: false }
            )
          }, 1000)
        } else if (state.conditionsBeingActivated[condition_id]) {
          /* only initiate next timer if condition is present
          this also handles the case where the condition is deleted
          and no need to track the status of it */
          timerIds[condition_id] = setTimeout(() => {
            getStatusAndInitiateTimer()
          }, 10000)
        }
      })
    }
    // initial delay 15sec
    timerIds[condition_id] = setTimeout(() => {
      getStatusAndInitiateTimer()
    }, 15000)
  },
  removeConditionStatusTracking({ commit }, condition_id) {
    /* remove any scheduled status check if the condition is deleted
    while it's running */
    clearTimeout(timerIds[condition_id])
    commit("REMOVE_PROGRESS", condition_id)
  },
}
